import { render } from "./Swap.vue?vue&type=template&id=33a077e8"
const script = {}
script.render = render

export default script